import React, {useState, useContext} from 'react';
import { Link } from "react-router-dom";
import {IconButton, InputAdornment, FormGroup, FormControl, Grid, TextField, Button} from "@material-ui/core";
import { MaskedNumber, FormSelect, Form, SwitchValue, Alert, LabelledPaper, FormCheckbox, FormMemo } from '../../../controls';
import SystemContext from "../../../SystemContext";
import CountryPermitRequirementsValidator from "../validators/CountryPermitRequirementsValidator";
import PermitCompanyUuidLookup from "../../Companies/components/CompanyUuidLookup";
import { useUpdateCountryPermitRequirement } from "../../../services/permitRequirements";
import { OpenInBrowser } from '@material-ui/icons';
import DocumentTemplateLookup from '../../Settings/components/DocumentTemplateLookup';

const CountryPermitRequirementForm = (_props) => {
  const props = { 
    canEdit: false,   
    ..._props
  }

  const classes = props.classes;

  const [record, setRecord] = useState(props.record);
  const [editing, setEditing] = useState(false);
  const [alert, setAlert] = useState({
    open: false,
    severity: "error",
    message: ""
  });

  const SystemData = useContext(SystemContext);
  const eventBus = SystemData.eventBus;
  if (eventBus) {
    eventBus.bind('CountryPermitRequirementList.rowSelected', (record)=> {
      setRecord(record);
      setEditing(false);
    });
  }

  const handleUpdateCountryPermitRequirement = useUpdateCountryPermitRequirement();

  const extraKeys = [];

  // const formatChars={
  //   "U": "[A-Z]",
  //   "A": "[A-Z0-9]",
  //   "a": "[A-Za-z0-9]",
  //   "9": "[0-9]",
  //   "D": "[0-9.]",
  //   "-": "-",
  //   "x": "."
  // }

  const permitRouteTypes = {
    OVERFLIGHT:[{"code":"NONE","value":"None"},{"code":"BASIC","value":"Basic"},{"code":"CARGO","value":"Cargo"}],
    LANDING:[{"code":"NONE","value":"None"},{"code":"BASIC","value":"Basic"},{"code":"CARGO","value":"Cargo"},{"code":"CARGO INBOUND","value":"Cargo Inbound"},{"code":"CARGO OUTBOUND","value":"Cargo Ourbound"}],
    DEPARTURE:[{"code":"NONE","value":"None"},{"code":"BASIC","value":"Basic"},{"code":"CARGO","value":"Cargo"}]
  }
  const navigationViaOptions = [{"code":"OPERATOR","value":"Aircraft Operator"},{"code":"CHARTER","value":"Charter Operator"},{"code":"PARTNER","value":"Partner"}];

  return (
    <div key="formContainer" style={{width: "100%", textAlign:"left"}}>
      <Alert
        key="alert"
        onChange={(open) => {
          setAlert({ ...alert, open })
        }}
        open={alert.open}
        severity={alert.severity}
        message={alert.message}
        timeOut={alert.timeOut || 0}
      />
      {record
        ?
          <Form key="form"
            title={(record)=>{return `${record.permitType} Permit Requirements for ${record.countryName}`}}
            message=""
            open={true}
            record={record}
            validator={editing?CountryPermitRequirementsValidator:null}
            formBodyStyle={{maxHeight: "calc(100vh - 320px)"}}
            buttonBarStyle={{width: "calc(100% - 20px)"}}
            buttons = {editing?
              {
                save:{icon: "check_circle", key: "Save", label: "Save", color: "primary", disabled: (status)=>{return status.error}},
                cancel:{icon: "cancel", key: "Cancel", label: "Cancel", color: "primary"}
              }: props.canEdit?{
                edit: {icon: "edit", key: "Edit", label: "Edit", color: "primary"}
              }: {}
            }

            // validator={AddTripValidator}
            onChange={(state) => {
              if (state.buttonPressed === "edit" && props.canEdit) {
                setEditing(true);
              }
              if (state.buttonPressed === "cancel") {
                setEditing(false);
                setRecord(props.record);
              }
              if (state.buttonPressed === "save") {
                SystemData.toggleLoadingProgress(true);
                const record = state.record;
                handleUpdateCountryPermitRequirement.mutate({
                  extraKeys,
                  record,
                  postSuccess: () => {
                    setEditing(false);
                    SystemData.toggleLoadingProgress(false);
                    setAlert({ severity: "info", open: true, message: "Record Updated", timeOut: 5 });
                  },
                  postError: (data) => {
                    SystemData.toggleLoadingProgress(false);
                    if (data.errorMessage) {
                      SystemData.alert("Error", `${data.errorMessage}`);
                    } else {
                      SystemData.alert("Error", `An Unexpected Error has occurred creating the trip.`);
                    }
                  }
                });
              } else {
              }
            }}
          >
            {/* countryPermitRequirementUuid, countryUuid, permitType, companyUuid, validOnDayOfFlightOnly, permitValidityHours */}
            <Grid container checkChildren={true} spacing={3}>
              <Grid item xs={4} checkChildren={true}>
                <PermitCompanyUuidLookup
                  id="companyUuid"
                  label="Permit Supplier"
                  inputProps={{readOnly:editing!==true}}
                  readOnly={editing!==true}
                  shrink="true"
                  companyType={"PERMIT_SUPPLIER"}
                  returnType={"object"}
                  alwaysShowCompanyName={true}
                  onChange={(returnObject, props) => {
                    if (returnObject.found) {
                      const supplier = returnObject.data
                      const data = {
                        companyName: supplier.companyName,
                        companyUuid: supplier.companyUuid,
                      }
                      props.recordChange(data);
                    } else {
                      props.onChange(returnObject.value);
                    }
                  }}
                />
              </Grid>
              <Grid item xs={2} checkChildren={true}>
                <FormCheckbox
                  id="validOnDayOfFlightOnly"
                  key="validOnDayOfFlightOnly"
                  label="D.O.F Only"
                  className={classes.checkbox}
                  readOnly={editing!==true}
                />
              </Grid>
              <Grid item xs={2} checkChildren={true}>
                <MaskedNumber
                  id="permitValidityHours"
                  label="Validity Period (Hours)"
                  decimalScale={0}
                  format={"###"}
                  fixedDecimalScale={true}
                  readOnly={editing!==true}
                />
              </Grid>
              <Grid item xs={2} checkChildren={true}>
                <MaskedNumber
                  id="permitPreDepartureValidityHours"
                  label="Pre Departure (Hours)"
                  decimalScale={0}
                  format={"###"}
                  fixedDecimalScale={true}
                  readOnly={editing!==true}
                />
              </Grid>
              <Grid item xs={2} checkChildren={true}>
                <MaskedNumber
                  id="permitRequestLeadTimeHours"
                  label="Lead Time (Hours)"
                  decimalScale={0}
                  format={"###"}
                  fixedDecimalScale={true}
                  readOnly={editing!==true}
                />
              </Grid>
              <Grid item xs={6} checkChildren={true}>
                <FormSelect
                  id="permitRouteType"
                  label="Permit Route Type"
                  options={permitRouteTypes && permitRouteTypes[record.permitType]?permitRouteTypes[record.permitType]:null}
                  readOnly={editing!==true}
                />
              </Grid>
              <Grid item xs={2} checkChildren={true}>
                <MaskedNumber
                  id="permitCostAgent"
                  label="Agent Cost"
                  decimalScale={2}
                  fixedDecimalScale={true}
                  readOnly={editing!==true}
                />
              </Grid>
              <Grid item xs={2} checkChildren={true}>
                <MaskedNumber
                  id="permitCostAuthority"
                  label="Authority Cost"
                  decimalScale={2}
                  fixedDecimalScale={true}
                  readOnly={editing!==true}
                />
              </Grid>
              <Grid item xs={2} checkChildren={true}>
                <FormSelect
                  id="navigationFeesVia"
                  label="Navigation Fees Via"
                  options={navigationViaOptions}
                  readOnly={editing!==true}
                />
              </Grid>

              <Grid item xs={12} checkChildren={true}>
                <LabelledPaper checkChildren={true} label="Aircraft Requirements">
                  <FormControl checkChildren={true} key="FC-aircraft">
                    <FormGroup checkChildren={true} key="FG-aircraft" row>
                      <FormCheckbox
                        id="requiresOperatorDetails"
                        key="requiresOperatorDetails"
                        label="Operator Details"
                        className={classes.checkbox}
                        readOnly={editing!==true}
                      />
                      <FormCheckbox
                        id="requiresAircraftDetails"
                        key="requiresAircraftDetails"
                        label="Aircraft Details"
                        className={classes.checkbox}
                        readOnly={editing!==true}
                      />
                      <FormCheckbox
                        id="requiresAircraftDocuments"
                        key="requiresAircraftDocuments"
                        label="Aircraft Documents"
                        className={classes.checkbox}
                        readOnly={editing!==true}
                      />
                      <FormCheckbox
                        id="substituteAircraftAllowed"
                        key="substituteAircraftAllowed"
                        label="Substitute Aircraft"
                        className={classes.checkbox}
                        readOnly={editing!==true}
                      />
                      <FormCheckbox
                        id="requiresCrewNumber"
                        key="requiresCrewNumber"
                        label="Crew Number"
                        className={classes.checkbox}
                        readOnly={editing!==true}
                      />
                      <FormCheckbox
                        id="requiresCrewDetails"
                        key="requiresCrewDetails"
                        label="Crew Details"
                        className={classes.checkbox}
                        readOnly={editing!==true}
                      />
                    </FormGroup>
                  </FormControl>
                </LabelledPaper>
              </Grid>
              <Grid item xs={12} checkChildren={true}>
                <LabelledPaper checkChildren={true} label="Flight Requirements">
                  <FormControl checkChildren={true} key="FC-flight">
                    <FormGroup checkChildren={true} key="FG-flight" row>
                      <FormCheckbox
                        id="requiresSchedule"
                        key="requiresSchedule"
                        label="Flight Schedule"
                        className={classes.checkbox}
                        readOnly={editing!==true}
                      />
                      <FormCheckbox
                        id="requiresFirRouting"
                        key="requiresFirRouting"
                        label="FIR Routing"
                        className={classes.checkbox}
                        readOnly={editing!==true}
                      />
                      <FormCheckbox
                        id="requiresIcaoFlightPlan"
                        key="requiresIcaoFlightPlan"
                        label="ICAO Flight Plan"
                        className={classes.checkbox}
                        readOnly={editing!==true}
                      />
                      <FormCheckbox
                        id="requiresCargoDetails"
                        key="requiresCargoDetails"
                        label="Cargo Details"
                        className={classes.checkbox}
                        readOnly={editing!==true}
                      />
                      <FormCheckbox
                        id="requiresAirWaybills"
                        key="requiresAirWaybills"
                        label="Air Waybills"
                        className={classes.checkbox}
                        readOnly={editing!==true}
                      />
                      <FormCheckbox
                        id="requiresCargoManifest"
                        key="requiresCargoManifest"
                        label="Cargo Manifest"
                        className={classes.checkbox}
                        readOnly={editing!==true}
                      />
                      <FormCheckbox
                        id="requiresConsignorConsignee"
                        key="requiresConsignorConsignee"
                        label="Consignee / Consignor"
                        className={classes.checkbox}
                        readOnly={editing!==true}
                      />
                    </FormGroup>
                  </FormControl>
                </LabelledPaper>
              </Grid>
              <Grid item xs={12} checkChildren={true}>
                <LabelledPaper checkChildren={true} label="Legal Requirements">
                  <FormControl checkChildren={true} key="FC-legal">
                    <FormGroup checkChildren={true} key="FG-legal" row>
                      <FormCheckbox
                        id="requiresLetterOfSupport"
                        key="requiresLetterOfSupport"
                        label="Support Letter"
                        className={classes.checkbox}
                        readOnly={editing!==true}
                      />
                      <FormCheckbox
                        id="requiresNoObjections"
                        key="requiresNoObjections"
                        label="No Objections"
                        className={classes.checkbox}
                        readOnly={editing!==true}
                      />
                      <FormCheckbox
                        id="requiresCharterAgreement"
                        key="requiresPowerOfAttorney"
                        label="Charter Agreement"
                        className={classes.checkbox}
                        readOnly={editing!==true}
                      />
                    </FormGroup>
                  </FormControl>
                </LabelledPaper>
              </Grid>
              <Grid item xs={6} checkChildren="true">
                {(record) =>
                  <SwitchValue
                    id="usesSpecificForm"
                    color="primary"
                    label="Use Specific Form"
                    readOnly={editing!==true}
                    onChange={(value, props) => {
                      if (value === false) {
                        props.recordChange({usesSpecificForm: value, specificFormTemplateUuid: null})
                      } else {
                        props.onChange(value);
                      }
                    }}
                  />
                }
                {(record) => record.usesSpecificForm===true?
                  <DocumentTemplateLookup
                    id="specificFormTemplateUuid"
                    label="Form File"
                    inputProps={{readOnly:editing!==true}}
                    readOnly={editing!==true}
                    shrink="true"
                    documentType="PERMIT APPLICATION"
                  />
                :<></>
              }
              </Grid>
              <Grid item xs={6} checkChildren="true">
                {(record) =>
                  <SwitchValue
                    id="usesOnlineApplication"
                    color="primary"
                    label="Use Online Application"
                    readOnly={editing!==true}
                    onChange={(value, props) => {
                      if (value === false) {
                        props.recordChange({usesOnlineApplication: value, onlineApplicationUrl: null})
                      } else {
                        props.onChange(value);
                      }
                    }}
                  />
                }
                {(record) => record.usesOnlineApplication===true?
                    <TextField
                      id="onlineApplicationUrl"
                      label="Application Website URL"
                      readOnly={editing!==true}
                      shrink={true}
                      InputLabelProps={{ shrink: true }}
                      style={{width: "100%"}}
                      fullWidth
                      InputProps={{
                        readOnly:editing!==true,
                        shrink: true,
                        endAdornment:
                          <InputAdornment position="end">
                            <Link to={{pathname: record.onlineApplicationUrl}} target="_blank" rel="noopener noreferrer">
                            <IconButton
                              aria-label="Open in browser"
                              edge="end"
                            >
                              {record && record.onlineApplicationUrl ? <OpenInBrowser /> : <></>}
                            </IconButton>
                            </Link>
                          </InputAdornment>
                        }}
                    />
                  :
                <></>
              }
              </Grid>
              <Grid item xs={12} checkChildren={true}>
                <FormMemo
                  id="applicationNotes"
                  label="Application Notes"
                  readOnly={editing!==true}
                  shrink={true}
                />
              </Grid>
              <Grid item xs={12} checkChildren={true}>
                <FormMemo
                  id="notes"
                  label="Notes"
                  readOnly={editing!==true}
                  shrink={true}
                />
              </Grid>
            </Grid>
          </Form>
        :
          <div style={{position: "relative", width: "100%", top: "50%", height: "30px", textAlign: "center"}}>
            <Button color={"primary"}>Select a Country to view permit requirements details</Button>
          </div>
      }
    </div>
  );
}

export default CountryPermitRequirementForm;
